import React from 'react'

const Loading = () => {
  return (
    <div className="flex justify-center items-center h-screen">
      <span className="loader"></span>
    </div>
  )
}

export default Loading